import { render, staticRenderFns } from "./CodeInput.vue?vue&type=template&id=498a3c2e&scoped=true"
import script from "./CodeInput.vue?vue&type=script&lang=ts"
export * from "./CodeInput.vue?vue&type=script&lang=ts"
import style0 from "./CodeInput.vue?vue&type=style&index=0&id=498a3c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498a3c2e",
  null
  
)

export default component.exports